import React, { Component } from 'react'
import { connect } from "react-redux";
import { Helmet } from 'react-helmet-async';
import { Button } from 'reactstrap';
import IconButton from '@mui/material/IconButton';
import MatButton from '@mui/material/Button';
import MUIDataTable from "mui-datatables";

// intl messages
import IntlMessages from 'Util/IntlMessages';
// page title bar
import PageTitleBar from 'Components/PageTitleBar/PageTitleBar';
// app config
import AppConfig from 'Constants/AppConfig';


import ConfirmationDialog from "Routes/common/ConfirmationDialog";

import {
   allInjuryChart,
   addInjuryChart,
   editInjuryChart,
   deleteInjuryChart,
   fetchInjuryChart,
   allInjuryUpdate
} from 'Actions';

// rct card box
import RctCollapsibleCard from 'Components/RctCollapsibleCard/RctCollapsibleCard';

import AddElement from './component/addinjury';
import EditElement from'./component/editinjury';
import UpdateElement from './component/updateinjury';

import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';

class injurychart extends Component {
   
   constructor(props) {
      
      super(props);
        this.confirmationDialog = React.createRef();
         this.state = {
            viewdiv:true,
            adddiv:false,
            editdiv:false,
            updatdiv:false,
            eid:'',
            edname:'',
            eddesignation:'',
            edemail:'',
            edmobile:'',
            injuryid:'',
         };      
      this.addHandleSubmit = this.addHandleSubmit.bind(this); 
      this.deleteAssessment = this.deleteAssessment.bind(this); 
      this.editTeam = this.editTeam.bind(this);
      this.editHandleSubmit = this.editHandleSubmit.bind(this);
      this.onBackSection = this.onBackSection.bind(this);
      this.editAssessment = this.editAssessment.bind(this);
      this.UpdateAssessment = this.UpdateAssessment.bind(this);
      
   }

   UNSAFE_componentWillMount() {
		this.props.allInjuryChart();
	}
   
   addHandleSubmit(event) {
      event.preventDefault();
      this.props.addInjuryChart(event).then((data) => {   
           
        if(data.status==1){
                
                document.getElementById("ssteamform").reset();
        }
    });
      
   }

   editAssessment(rowid){
      
      this.props.fetchInjuryChart(rowid).then((data) => {   
         var resdata=data.data;
         
         this.setState({ 
            viewdiv:false,
            adddiv:false,
            editdiv:true
             });
      });
      
   }

   UpdateAssessment(rowid){
      
      this.props.allInjuryUpdate(rowid).then((data) => {   
         //var resdata=data.data;
         
         this.setState({ 
            injuryid:rowid,
            viewdiv:false,
            adddiv:false,
            editdiv:false,
            updatdiv:true
             });
      });
      
   }

   onAddSession() {
		this.setState({ 
         viewdiv:false,
         editdiv:false,
         adddiv:true
          });
	}   

   deleteAssessment(data){
        this.data = data;
        this.confirmationDialog.current.openDialog();
    }

    deleteDataPermanent(popupResponse){
        
        if (popupResponse) {
            this.props.deleteInjuryChart(this.data);
            this.data = ""
        }
    }

   editTeam(rawdata){    
      this.setState({
         eid:rawdata.sctID,
         edname:rawdata.sc_name,        
         eddesignation:rawdata.sc_designation,        
         edemail:rawdata.sc_email,        
         edmobile:rawdata.sc_phone,        
         adddiv:false,
         editdiv:true
      });
   }

   editHandleSubmit(event) {
      event.preventDefault();
      this.props.editInjuryChart(event,this.state.eid);      
   }

   

   onBackSection() {
		this.setState({ 
         adddiv:false,
         editdiv:false,
         updatdiv:false,
         viewdiv:true
       });
	}

    render() {
       const { match, injurychartlists, loading } = this.props;
       const options = {
            filterType: 'dropdown',
            rowsPerPage: 50,
            rowsPerPageOptions: [50, 100, 150],
            selectableRowsHideCheckboxes: true,
        };

        const columns = [
            { name: "no", label: "No" },
            { name: "name", label: "Name" },
            { name: "date", label: "Date" },
            { name: "edit", label: "Edit" },
            { name: "update", label: "Update" },
            { name: "delete", label: "Delete" }
        ];
        const tabledata=injurychartlists.map((assmntval,idx) => {            
            
                const ebtn=<IconButton className='text-info' onClick={ ()=>this.editAssessment(assmntval.sicID)}><EditOutlinedIcon/></IconButton>;
                const dbtn=<IconButton className="text-danger" aria-label="Delete" onClick={ ()=>this.deleteAssessment(assmntval.sicID)}><DeleteOutlineOutlinedIcon/></IconButton>;
                const upbtn=<MatButton variant="contained" onClick={ ()=>this.UpdateAssessment(assmntval.sicID)} className="btn-info mr-10 mb-10 text-white">Injury Update</MatButton>;
                return {
                no:idx+1,
                name: assmntval.student,
                date: assmntval.cdate,
                edit: ebtn,
                update: upbtn,
                delete:dbtn
                }
        });
       return (
          <div className="saas-dashboard">
             <Helmet>
                <title>Athlete Injury Chart  | {AppConfig.appTitle}</title>
                <meta name="description" content="Sport Science Team" />
             </Helmet>
             <PageTitleBar title={<IntlMessages id="sidebar.injurychartheading" />} match={match} />
            
              {this.state.viewdiv && 
                  <div className="col-sm-12 col-md-8">
                     <RctCollapsibleCard heading="List" fullBlock>
                        <MUIDataTable
                              title={<div><Button onClick={ ()=>this.onAddSession()} className="btn btn-outline-info"><i className="zmdi zmdi-plus-circle-o"></i>  Create Injury Chart</Button></div>}
                              data={tabledata}
                              columns={columns}
                              options={options} 
                        />   
                     </RctCollapsibleCard>
                  </div>  
               } 
               {this.state.adddiv && 
                  <AddElement onClick={this.onBackSection}/>
               }

               {this.state.editdiv && 
                  <EditElement onClick={this.onBackSection} data={this.state}/>
               }

               {this.state.updatdiv && 
                  
                  <UpdateElement onClick={this.onBackSection} data={this.state}/>
               }
            
             <ConfirmationDialog
               ref={this.confirmationDialog}
               onConfirm={(res) => this.deleteDataPermanent(res)}
               data={'injury chart'}
            />
          </div>
       )
    }
 }




const mapStateToProps = ({ injurychart }) => {
	const { injurychartlists, loading } = injurychart;
	return { injurychartlists, loading };
}

export default connect(mapStateToProps, {
    allInjuryChart,
    addInjuryChart,
    editInjuryChart,
    deleteInjuryChart,
    fetchInjuryChart,
    allInjuryUpdate
})(injurychart); 